import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 0c11.045 0 20 8.954 20 20s-8.955 20-20 20c0-.87-2.61-20-2.61-20L20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "m24.297 16.164-1.641 2.261-2.658-.862 1.644 2.26-1.64 2.26 2.656-.864 1.643 2.26-.001-2.795 2.656-.865-2.657-.861-.002-2.794Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M21.659 25.652a5.652 5.652 0 1 1 2.689-10.625 6.957 6.957 0 1 0 0 9.945c-.8.434-1.716.68-2.69.68Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function _(r, a) {
  return e(), l("svg", o, [...d]);
}
const f = { render: _ };
export {
  f as default,
  _ as render
};
